import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Mission from "./components/Mission";
import Courses from "./components/Courses";
import UpcomingCourses from "./components/UpcomingCourses";
import PaymentMethods from "./components/PaymentMethods";
import Benefits from "./components/Benefits";
import TikTokVideos from "./components/TikTokVideos";
import Testimonials from "./components/Testimonials";
import Location from "./components/Location";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import WhatsAppFloat from "./components/WhatsAppFloat";
import SeoJsonLd from "./components/SeoJsonLd";

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <SeoJsonLd />
      <Navbar />
      <main>
        <Hero />
        <About />
        <Mission />
        <Courses />
        <UpcomingCourses />
        <PaymentMethods />
        <Benefits />
        <TikTokVideos />
        <Testimonials />
        <Location />
        <Contact />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
